<script>
import { ref, onMounted } from "vue";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'StoryBlock',
  setup() {
    const leftElement = ref(null)
    const rightElement = ref(null)

    onMounted(() => {
      gsap.fromTo(
          leftElement.value,
          { x: "-100%", opacity: 0 },
          {
            x: "0%",
            opacity: 1,
            duration: 1.5,
            ease: "power2.out",
            scrollTrigger: {
              trigger: leftElement.value,
              start: "top 80%",
            },
          }
      )
      gsap.fromTo(
          rightElement.value,
          { x: "100%", opacity: 0 },
          {
            x: "0%",
            opacity: 1,
            duration: 1.5,
            ease: "power2.out",
            scrollTrigger: {
              trigger: rightElement.value,
              start: "top 80%",
            },
          }
      )
    })

    return {
      leftElement,
      rightElement,
    }
  },
}
</script>

<template>
  <div class="bg-white">
    <div class="flex flex-wrap justify-between lg:px-4 lg:py-10">
      <div class="px-10 py-5 w-full lg:mt-10 lg:w-1/2" ref="leftElement">
        <h1 class="text-primary-700 text-4xl lg:text-7xl font-extrabold uppercase font-sigmar tracking-wider">Il était <br> une fois...</h1>
        <h2 class="mt-10 uppercase text-2xl text-primary-800">L'histoire de déglingo</h2>
        <p class="mt-10 text-primary-800">
          La Déglingo a été brassée pour la première fois le 26 décembre 1988. Notre équipe de brasseurs a créé cette
          bière à la demande des Français. L'authenticité de la Déglingo réside dans les 3 levures différentes qu'elle
          contient ainsi que dans sa bouteille originale en terre cuite.
        </p>
        <router-link
            to="/histoire"
            class="mt-6 px-6 py-3 border-2 border-primary-800 w-full lg:w-1/3 text-primary-800 font-semibold rounded-full flex justify-between items-center hover:text-white hover:bg-primary-800 hover:shadow-md transition"
        >
          Lire la suite
          <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 ml-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
          >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M17 8l4 4m0 0l-4 4m4-4H3"
            />
          </svg>
        </router-link>
      </div>
      <div class="w-full lg:w-1/2 lg:h-full flex justify-center items-center" ref="rightElement">
        <img
            src="/history.jpg"
            alt="Image histoire de la brasserie"
            class="w-4/5 rounded-[2.5rem] shadow-2xl"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Ajoutez des styles si nécessaire */
</style>
